import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useContext } from 'react';
import { AuthContext } from 'context/authContext';

export default function useGetEmployeeBankDetails() {
  const { authState } = useContext(AuthContext);
  return useQuery(['get-employee-bank-details'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_BANK_DETAILS, {
        employee_id: authState?.employee_id
      })
    );
    return res.data;
  });
}
